// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "color-fill-module--base-text-alt--global--7db9b";
export var baseTextGlobal = "color-fill-module--base-text--global--8b325";
export var beige = "color-fill-module--beige--17a2f";
export var black = "color-fill-module--black--3dcbe";
export var blockSpacing100 = "color-fill-module--block-spacing-100--84a38";
export var blockSpacing50 = "color-fill-module--block-spacing-50--5a6cb";
export var blockVPadding100 = "color-fill-module--block-v-padding-100--d0907";
export var blockVPadding50 = "color-fill-module--block-v-padding-50--f684e";
export var blue = "color-fill-module--blue--97bb0";
export var brown = "color-fill-module--brown--00146";
export var captionTextGlobal = "color-fill-module--caption-text--global--dc7f9";
export var cmsRenderedContentGlobal = "color-fill-module--cms-rendered-content--global--b260f";
export var colorFill = "color-fill-module--colorFill--735e0";
export var defaultHSpacingGlobal = "color-fill-module--default-h-spacing--global--a0409";
export var fadeInAnimation = "color-fill-module--fadeInAnimation--0cc8b";
export var fadeInOnLoadGlobal = "color-fill-module--fade-in-on-load--global--f6a9c";
export var fullHeightGlobal = "color-fill-module--full-height--global--9a2a8";
export var fullHeightOmittingNavGlobal = "color-fill-module--full-height-omitting-nav--global--d86e7";
export var gray = "color-fill-module--gray--c5cb6";
export var headingTextGlobal = "color-fill-module--heading-text--global--8a8f9";
export var ingressTextGlobal = "color-fill-module--ingress-text--global--b4ef3";
export var linkColorChangeTransitionGlobal = "color-fill-module--link-color-change-transition--global--c269e";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "color-fill-module--page-heading-text--global--fa4cd";
export var paragraphTextGlobal = "color-fill-module--paragraph-text--global--6cb45";
export var subheadingTextGlobal = "color-fill-module--subheading-text--global--c0744";
export var white = "color-fill-module--white--48a80";